/**
 * 51esc web — entry point: `/logbook.html`.
 *
 * Lista de pilotos del escuadrón. Layout de cuaderno con anillas: la
 * tabla de pilotos vive en la página izquierda, el panel "INFORMACIÓN"
 * en la derecha (placeholder hasta que el usuario seleccione un piloto).
 */

import { mountLogbookList } from './modules/logbook/mount.js';

void mountLogbookList();
